<template>
  <div>
    <form data-vv-scope="custom-document" autocomplete="off" @submit.prevent>
      <h2 class="mb-10">
        {{ reportTypeText }} Informe de Desempeño Proceso de Calificaciones
      </h2>
      <div class="row">
        <div class="col-12 col-lg-6">
          <b-form-group label="Tipo de Informe *">
            <b-form-select
              :disabled="loadingReportTypes"
              class="w-100"
              data-cy="report-type"
              name="reportType"
              data-vv-as="tipo de informe"
              v-model="reportType"
              :state="errors.has('custom-document.reportType') ? false : null"
              v-validate="'required'"
              :options="reportTypeOptions"
              @input="setReportType"
            >
              <option
                v-if="loadingReportTypes"
                :value="null"
                disabled
              >
                Cargando tipos de informe...
              </option>
              <option
                v-else
                :value="null"
                disabled
              >
                -- Selecciona un tipo de informe --
              </option>
            </b-form-select>
            <ValidationError
              document="custom-document"
              validation="reportType"
              :validator-errors="errors"
            />
          </b-form-group>
        </div>
        <div class="col-12 col-md-6 col-lg-3">
          <b-form-group label="Inicio periodo (Auto)">
            <date-picker
              disabled
              placeholder="Seleccione un tipo de informe"
              :input-class="{
                'mx-input':true,
                'border-danger':errors.has('custom-document.initialDate')
              }"
              data-cy="initial-date"
              class="w-100"
              name="initialDate"
              format="DD-MM-YYYY"
              value-type="YYYY-MM-DD"
              data-vv-as="fecha inicial"
              :danger="errors.has('custom-document.initialDate')"
              :danger-text="errors.first('custom-document.initialDate')"
              v-validate="'required'"
              v-model="formData.initialDate"
            />
            <ValidationError
              document="custom-document"
              validation="initialDate"
              :validator-errors="errors"
            />
          </b-form-group>
        </div>
        <div class="col-12 col-md-6 col-lg-3">
          <b-form-group label="Fin periodo (Auto)">
            <date-picker
              disabled
              placeholder="Seleccione un tipo de informe"
              :input-class="{
                'mx-input':true,
                'border-danger':errors.has('custom-document.finalDate')
              }"
              data-cy="final-date"
              class="w-100"
              name="finalDate"
              format="DD-MM-YYYY"
              value-type="YYYY-MM-DD"
              data-vv-as="fecha final"
              :danger="errors.has('custom-document.finalDate')"
              :danger-text="errors.first('custom-document.finalDate')"
              v-validate="'required'"
              v-model="formData.finalDate"
            />
            <ValidationError
              document="custom-document"
              validation="finalDate"
              :validator-errors="errors"
            />
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <b-form-group label="Institución (Auto)">
            <b-form-input
              disabled
              :state="errors.has('custom-document.institution') ? false : null"
              data-cy="institution"
              data-vv-as="institución"
              name="institution"
              type="text"
              v-model="formData.institution"
              v-validate="'required'"
            />
            <ValidationError
              document="custom-document"
              validation="institution"
              :validator-errors="errors"
            />
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <b-form-group label="División *">
            <list-groups
              :danger="errors.has('custom-document.division')"
              :danger-text="errors.first('custom-document.division')"
              v-validate="'required'"
              data-vv-as="división"
              autocomplete
              label=""
              name="division"
              data-cy="division"
              ref="division"
              v-model="division"
              :typeList="stepTypes.GROUP"
              showOnlyDivissions
              @full-group="setDivision"
            />
          </b-form-group>
        </div>
        <div class="col-12 col-md-6">
          <b-form-group label="Funcionario *">
            <list-user
              :division-filter="division"
              autocomplete
              class="w-100"
              data-cy="functionary"
              data-vv-as="funcionario"
              name="functionary"
              label=""
              v-model="functionary"
              :danger="errors.has('custom-document.functionary')"
              :danger-text="errors.first('custom-document.functionary')"
              v-validate="'required'"
              ref="functionary"
              filters-user-group="esOficina:N"
              @set-position="setFunctionary"
              @input="resetFunctionary"
            />
          </b-form-group>
        </div>
        <div class="col-12 col-md-6">
          <b-form-group label="Departamento *">
            <b-form-input
              :disabled="loadingFunctionaryInfo"
              :state="errors.has('custom-document.department') ? false : null"
              data-cy="department"
              data-vv-as="departamento"
              name="department"
              type="text"
              v-model="formData.department"
              v-validate="'required'"
              :placeholder="departmentLoadingText"
            />
            <ValidationError
              document="custom-document"
              validation="department"
              :validator-errors="errors"
            />
          </b-form-group>
        </div>
        <div class="col-12 col-lg-6">
          <b-form-group label="Estamento *">
            <b-form-select
              class="w-100"
              data-cy="estate"
              name="estate"
              data-vv-as="estamento"
              v-model="formData.estate"
              :state="errors.has('custom-document.estate') ? false : null"
              v-validate="'required'"
              :options="estateOptions"
            />
            <ValidationError
              document="custom-document"
              validation="estate"
              :validator-errors="errors"
            />
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-6">
          <b-form-group label="Grado *">
            <b-form-select
              class="w-100"
              data-cy="degree"
              name="degree"
              data-vv-as="grado"
              v-model="formData.degree"
              :state="errors.has('custom-document.degree') ? false : null"
              v-validate="'required'"
              :options="degreeOptions"
            />
            <ValidationError
              document="custom-document"
              validation="degree"
              :validator-errors="errors"
            />
          </b-form-group>
        </div>
        <div class="col-12 col-md-6">
          <b-form-group label="Jefe/a Directo *">
            <list-user
              v-if="!disableDirectBossChange || directBoss == null"
              :disabled="loadingFunctionaryInfo"
              autocomplete
              class="w-100"
              data-cy="direct-boss"
              data-vv-as="jefe/a directo"
              name="directBoss"
              label=""
              :placeholder="loadingFunctionaryInfo ? 'Cargando...' : null"
              v-model="directBoss"
              :danger="errors.has('custom-document.directBoss')"
              :danger-text="errors.first('custom-document.directBoss')"
              v-validate="{
                'required': !disableDirectBossChange || directBoss == null
              }"
              ref="directBoss"
              filters-user-group="esOficina:N"
              @set-position="setDirectBoss"
            />
            <b-form-input
              v-else
              disabled
              data-cy="directBoss"
              name="directBoss"
              type="text"
              v-model="formData.directBoss"
              placeholder="Cargando..."
              :value="directBoss || 'Cargando...'"
            />
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p>
            <b>1. <u>RENDIMIENTO</u>:</b>
            Mide el volumen de trabajo ejecutado y la calidad durante el período,
            destacando la ausencia de errores en relación a las tareas encomendadas.
          </p>
          <p>
            <b>1.a.</b> <u>Cantidad de Trabajo</u>:
            Mide el volumen de trabajo desarrollado y la rapidez y oportunidad de su ejecución.
          </p>
        </div>
        <div class="col-12">
          <b-form-group>
            <b-form-textarea
              rows="4"
              class="-mt-2"
              :state="errors.has('custom-document.workAmount') ? false : null"
              data-cy="work-amount"
              data-vv-as="cantidad de trabajo"
              name="workAmount"
              v-model="formData.workAmount"
              v-validate="'required'"
              :maxlength="inputMaxLength"
            />
            <div class="text-right">
              <span v-tooltip="'Contador de caracteres'">
                {{formData.workAmount.length}}/{{inputMaxLength}}
              </span>
            </div>
            <ValidationError
              document="custom-document"
              validation="workAmount"
              :validator-errors="errors"
            />
          </b-form-group>
        </div>
        <div class="col-12">
          <p>
            <b>1.b.</b> <u>Calidad de la labor realizada</u>:
            Evalúa las características de la labor cumplida.
            Mide la ausencia de errores en el trabajo y la habilidad en su ejecución.
          </p>
          <p>
            <b>1.b.1.-</b> <u>Ausencia de errores en el trabajo y
            habilidad en la ejecución de la tarea</u>.
          </p>
        </div>
        <div class="col-12">
          <b-form-group>
            <b-form-textarea
              rows="4"
              class="-mt-2"
              :state="errors.has('custom-document.workQuality') ? false : null"
              data-cy="work-quality"
              data-vv-as="calidad de la labor realizada"
              name="workQuality"
              v-model="formData.workQuality"
              v-validate="'required'"
              :maxlength="inputMaxLength"
            />
            <div class="text-right">
              <span v-tooltip="'Contador de caracteres'">
                {{formData.workQuality.length}}/{{inputMaxLength}}
              </span>
            </div>
            <ValidationError
              document="custom-document"
              validation="workQuality"
              :validator-errors="errors"
            />
          </b-form-group>
        </div>
        <div class="col-12">
          <p>
            <b>1.b.2.-</b> <u>Calidad de la Atención y Trato al Usuario o Cliente Interno</u>:
            Mide el grado de amabilidad, cortesía, disposición y trato al usuario interno y externo.
          </p>
        </div>
        <div class="col-12">
          <b-form-group>
            <b-form-textarea
              rows="4"
              class="-mt-2"
              :state="errors.has('custom-document.attentionQuality') ? false : null"
              data-cy="attention-quality"
              data-vv-as="calidad de la atención"
              name="attentionQuality"
              v-model="formData.attentionQuality"
              v-validate="'required'"
              :maxlength="inputMaxLength"
            />
            <div class="text-right">
              <span v-tooltip="'Contador de caracteres'">
                {{formData.attentionQuality.length}}/{{inputMaxLength}}
              </span>
            </div>
            <ValidationError
              document="custom-document"
              validation="attentionQuality"
              :validator-errors="errors"
            />
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p>
            <b>2. <u>CONDICIONES PERSONALES</u>:</b>
            Evalúa aquellas aptitudes del funcionario vinculadas directamente con el
            cumplimiento de sus funciones.
          </p>
          <p>
            <b>2.a.-</b> <u>Conocimiento del trabajo</u>:
            Mide el grado de conocimiento que la persona tiene de la actividad que realiza,
            los conocimientos teóricos, estudios y los cursos de formación o de especialización
            relacionados con las funciones del cargo.
          </p>
        </div>
        <div class="col-12">
          <b-form-group>
            <b-form-textarea
              rows="4"
              class="-mt-2"
              :state="errors.has('custom-document.workKnowledge') ? false : null"
              data-cy="work-knowledge"
              data-vv-as="conocimiento del trabajo"
              name="workKnowledge"
              v-model="formData.workKnowledge"
              v-validate="'required'"
              :maxlength="inputMaxLength"
            />
            <div class="text-right">
              <span v-tooltip="'Contador de caracteres'">
                {{formData.workKnowledge.length}}/{{inputMaxLength}}
              </span>
            </div>
            <ValidationError
              document="custom-document"
              validation="workKnowledge"
              :validator-errors="errors"
            />
          </b-form-group>
        </div>
        <div class="col-12">
          <p>
            <b>2.b.-</b> <u>Interés por el trabajo que realiza</u>:
            Mide el deseo del funcionario de perfeccionarse en el cumplimiento de sus
            obligaciones y la capacidad de obrar oportunamente, de proponer la realización
            de actividades y de soluciones ante los problemas que se presenten y de proponer
            objetivos o procedimientos nuevos para la mejor realización del trabajo asignado.
          </p>
          <p>
            <b>2.b.1-</b> <u>Interés por perfeccionarse</u>:
            Mide el deseo del funcionario de perfeccionarse en el cumplimiento de sus obligaciones,
            de adquirir nuevos conocimientos y grado de aplicación de estos.
          </p>
        </div>
        <div class="col-12">
          <b-form-group>
            <b-form-textarea
              rows="4"
              class="-mt-2"
              :state="errors.has('custom-document.workInterest') ? false : null"
              data-cy="work-interest"
              data-vv-as="interés por el trabajo"
              name="workInterest"
              v-model="formData.workInterest"
              v-validate="'required'"
              :maxlength="inputMaxLength"
            />
            <div class="text-right">
              <span v-tooltip="'Contador de caracteres'">
                {{formData.workInterest.length}}/{{inputMaxLength}}
              </span>
            </div>
            <ValidationError
              document="custom-document"
              validation="workInterest"
              :validator-errors="errors"
            />
          </b-form-group>
        </div>
        <div class="col-12">
          <p>
            <b>2.b.2-</b> <u>Capacidad para actuar oportunamente, Grado de Iniciativa en el
            Trabajo</u>: Mide el nivel de iniciativa que tiene el funcionario para resolver
            situaciones de menor envergadura, que se presentan a diario en su tarea.
          </p>
        </div>
        <div class="col-12">
          <b-form-group>
            <b-form-textarea
              rows="4"
              class="-mt-2"
              :state="errors.has('custom-document.workInitiative') ? false : null"
              data-cy="work-initiative"
              data-vv-as="capacidad para actuar oportunamente"
              name="workInitiative"
              v-model="formData.workInitiative"
              v-validate="'required'"
              :maxlength="inputMaxLength"
            />
            <div class="text-right">
              <span v-tooltip="'Contador de caracteres'">
                {{formData.workInitiative.length}}/{{inputMaxLength}}
              </span>
            </div>
            <ValidationError
              document="custom-document"
              validation="workInitiative"
              :validator-errors="errors"
            />
          </b-form-group>
        </div>
        <div class="col-12">
          <p>
            <b>2.c-</b> <u>Capacidad para realizar trabajos en grupo</u>:
            Mide la facilidad de integración del funcionario en equipos de trabajo,
            así como la colaboración eficaz que este presta cuando se requiere que
            trabaje con grupo de personas.
          </p>
        </div>
        <div class="col-12">
          <b-form-group>
            <b-form-textarea
              rows="4"
              class="-mt-2"
              :state="errors.has('custom-document.workGroup') ? false : null"
              data-cy="work-group"
              data-vv-as="capacidad para realizar trabajos en grupo"
              name="workGroup"
              v-model="formData.workGroup"
              v-validate="'required'"
              :maxlength="inputMaxLength"
            />
            <div class="text-right">
              <span v-tooltip="'Contador de caracteres'">
                {{formData.workGroup.length}}/{{inputMaxLength}}
              </span>
            </div>
            <ValidationError
              document="custom-document"
              validation="workGroup"
              :validator-errors="errors"
            />
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p>
            <b>3. <u>COMPORTAMIENTO FUNCIONARIO/A</u>:</b>
            Evalúa la conducta del funcionario en el cumplimiento de sus obligaciones,
            normas y procedimientos establecidos en la Institución y en las normas
            jurídicas que regulan la actividad.
          </p>
          <p>
            <b>3.a-</b> <u>Asistencia y Puntualidad</u>:
            Mide la presencia o ausencia del funcionario en el lugar de trabajo y
            la exactitud en el cumplimiento de la jornada laboral.
          </p>
        </div>
        <div class="col-12">
          <b-form-group>
            <b-form-textarea
              rows="4"
              class="-mt-2"
              :state="errors.has('custom-document.attendancePunctuality') ? false : null"
              data-cy="attendance-punctuality"
              data-vv-as="asistencia y puntualidad"
              name="attendancePunctuality"
              v-model="formData.attendancePunctuality"
              v-validate="'required'"
              :maxlength="inputMaxLength"
            />
            <div class="text-right">
              <span v-tooltip="'Contador de caracteres'">
                {{formData.attendancePunctuality.length}}/{{inputMaxLength}}
              </span>
            </div>
            <ValidationError
              document="custom-document"
              validation="attendancePunctuality"
              :validator-errors="errors"
            />
          </b-form-group>
        </div>
        <div class="col-12">
          <p>
            <b>3.b-</b> <u>Permanencia en el lugar de trabajo</u>:
            Mide la presencia del funcionario en su puesto de trabajo,
            sin considerar la ausencia por motivos laborales (reuniones,
            cometidos funcionarios, etc.).
          </p>
        </div>
        <div class="col-12">
          <b-form-group>
            <b-form-textarea
              rows="4"
              class="-mt-2"
              :state="errors.has('custom-document.workplacePermanence') ? false : null"
              data-cy="workplace-permanence"
              data-vv-as="permanencia en el lugar de trabajo"
              name="workplacePermanence"
              v-model="formData.workplacePermanence"
              v-validate="'required'"
              :maxlength="inputMaxLength"
            />
            <div class="text-right">
              <span v-tooltip="'Contador de caracteres'">
                {{formData.workplacePermanence.length}}/{{inputMaxLength}}
              </span>
            </div>
            <ValidationError
              document="custom-document"
              validation="workplacePermanence"
              :validator-errors="errors"
            />
          </b-form-group>
        </div>
        <div class="col-12">
          <p>
            <b>3.c-</b> <u>Cumplimiento de normas e instrucciones</u>:
            Mide el adecuado y oportuno respeto a los reglamentos e instrucciones de la Institución,
            a los demás deberes estatutarios, al cumplimiento de las tareas propias del cargo,
            y de las órdenes y cometidos que le impartan o encomienden sus superiores.
          </p>
        </div>
        <div class="col-12">
          <b-form-group>
            <b-form-textarea
              rows="4"
              class="-mt-2"
              :state="errors.has('custom-document.rulesCompliance') ? false : null"
              data-cy="rules-compliance"
              data-vv-as="cumplimiento de normas e instrucciones"
              name="rulesCompliance"
              v-model="formData.rulesCompliance"
              v-validate="'required'"
              :maxlength="inputMaxLength"
            />
            <div class="text-right">
              <span v-tooltip="'Contador de caracteres'">
                {{formData.rulesCompliance.length}}/{{inputMaxLength}}
              </span>
            </div>
            <ValidationError
              document="custom-document"
              validation="rulesCompliance"
              :validator-errors="errors"
            />
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 col-xl-4">
          <b-form-group label="Fecha Conocimiento *">
            <date-picker
              placeholder="Seleccione una fecha"
              :input-class="{
                'mx-input':true,
                'border-danger':errors.has('custom-document.knowledgeDate')
              }"
              data-cy="knowledge-date"
              class="w-100"
              name="knowledgeDate"
              format="DD-MM-YYYY"
              value-type="YYYY-MM-DD"
              data-vv-as="fecha de conocimiento"
              :danger="errors.has('custom-document.knowledgeDate')"
              :danger-text="errors.first('custom-document.knowledgeDate')"
              v-validate="'required'"
              v-model="formData.knowledgeDate"
            />
            <ValidationError
              document="custom-document"
              validation="knowledgeDate"
              :validator-errors="errors"
            />
          </b-form-group>
        </div>
      </div>
    </form>
    <div class="row justify-end">
      <vs-button
        class="mt-5 mr-5"
        data-cy="cancel"
        @click="back()"
        color="primary"
        :disabled="saving"
      >
        Cancelar
      </vs-button>
      <vs-button
        class="mt-5 mr-5"
        data-cy="save"
        @click="save()"
        color="success"
        :disabled="saving"
      >
        Crear
        <span
          v-show="saving"
          class="spinner-border spinner-border-sm text-primary"
        />
      </vs-button>
    </div>
  </div>
</template>

<script>

import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

import DatePicker from 'vue2-datepicker';
import { mapActions, mapGetters } from 'vuex';

import { ioCreateCustomDocument } from '@/febos/servicios/api/customDocuments.api';
import ListUser from '@/febos/chile/lists/components/ListUser';
import ListGroups from '@/febos/chile/lists/components/ListGroups';
import StepTypes from '@/febos/chile/dnt/mixins/StepTypes';
import ValidationError from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/ValidationError';
import { getUserById } from '@/febos/servicios/api/usuarios.api';
import { ioListOptions, queueTask, verifyQueueTask } from '@/febos/servicios/api/herramientas.api';

export default {
  name: 'IDPC',
  components: {
    ValidationError,
    ListGroups,
    ListUser,
    DatePicker,
  },
  data() {
    return {
      inputMaxLength: 1000,
      loadingReportTypes: false,
      reportTypeOptions: [],
      reportType: null,
      functionary: '',
      division: '',
      directBoss: null,
      loadingFunctionaryInfo: false,
      disableDirectBossChange: false,
      requiredFunctionaryInfo: {
        UNIDAD_DESEMPENO_ID: null,
        JEFATURA_ID: null,
        JEFATURA_CARGO: null,
        DEPARTAMENTO: null,
        FUNCIONES: [],
        FUNCIONESN: 0
      },
      estateOptions: [
        { value: 'Técnico', text: 'Técnico' },
        { value: 'Profesional', text: 'Profesional' },
        { value: 'Directivo', text: 'Directivo' }
      ],
      degreeOptions: Array(19).fill(0).map((_, i) => ({
        value: `Grado ${i + 4}`,
        text: `Grado ${i + 4}`
      })),
      formData: {
        workAmount: '',
        workQuality: '',
        attentionQuality: '',
        workKnowledge: '',
        workInterest: '',
        workInitiative: '',
        workGroup: '',
        attendancePunctuality: '',
        workplacePermanence: '',
        rulesCompliance: '',
        reportType: null,
        initialDate: null,
        finalDate: null,
        institution: 'GOBIERNO REGIONAL DE VALPARAISO',
        division: null,
        department: null,
        functionary: null,
        estate: null,
        degree: null,
        directBoss: null,
        knowledgeDate: null,
      },
      saving: false,
      error: {
        message: ''
      },
      stepTypes: StepTypes,
    };
  },
  computed: {
    ...mapGetters('Empresas', [
      'company',
      'usersCompany',
    ]),
    ...mapGetters('Management', [
      'workerData'
    ]),
    reportTypeText() {
      return this.reportType?.valor || '';
    },
    departmentLoadingText() {
      if (this.loadingFunctionaryInfo) {
        return 'Cargando...';
      }

      if (!this.functionary) {
        return 'Seleccione un funcionario';
      }

      return 'Ingrese un departamento';
    }
  },
  methods: {
    back() {
      /* eslint-disable no-restricted-globals */
      history.back();
    },
    setDivision(division) {
      this.formData.division = division.label;
    },
    setReportType(reportType) {
      this.formData.reportType = reportType.valor;
      this.formData.initialDate = reportType.extra.inicioPeriodo;
      this.formData.finalDate = reportType.extra.finPeriodo;
    },
    ...mapActions('Management', [
      'getWorkerData',
    ]),
    ...mapActions('Empresas', [
      'getUsersCompany',
    ]),
    setDirectBoss(user) {
      this.formData.directBoss = user.label;
    },
    resetFunctionary(user) {
      if (!user) {
        this.directBoss = null;
        this.formData.directBoss = null;
        this.formData.department = null;
      }
    },
    async setFunctionary(user) {
      this.formData.functionary = user.label;
      this.loadingFunctionaryInfo = true;
      this.disableDirectBossChange = false;

      await this.getWorkerData({
        tipoRespuesta: 2, // Hay 1 y 2
        elementoId: user.id,
        referenciaId: this.company.id,
        filtros: `nombre:${Object.keys(this.requiredFunctionaryInfo).join()}`
      });

      this.formData.department = this.workerData.DEPARTAMENTO?.valor || null;

      let jefe = null;
      if (this.workerData.JEFATURA_ID?.valor) {
        jefe = await getUserById(this.workerData.JEFATURA_ID?.valor);
      }

      if (jefe?.data?.usuario?.nombre) {
        this.directBoss = jefe?.data?.usuario?.nombre;
        this.formData.directBoss = this.directBoss;
        this.disableDirectBossChange = true;
      } else {
        this.directBoss = null;
        this.formData.directBoss = null;
      }

      if (this.workerData.DEPARTAMENTO?.valor) {
        this.formData.department = this.workerData.DEPARTAMENTO?.valor || null;
      }

      this.loadingFunctionaryInfo = false;
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async verifyTask(taskId, callBack) {
      this.$bvToast.toast(
        'Generando representación PDF',
        {
          title: 'Esto podría tardar unos minutos...',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 5000
        }
      );
      const response = await verifyQueueTask(taskId);
      try {
        switch (response.data.estado) {
          case 0: // Esta creada y aun no iniciado
          case 1: // Esta creada y aun no iniciado
          case 2:
            setTimeout(() => {
              this.verifyTask(taskId, callBack);
            }, 3000);
            break;
          case 3:
            if (response.data.avance > 100) {
              await this.verifyTask(taskId, callBack);
            } else if (response.data.resultado) {
              const fetchedJson = await fetch(response.data.resultado);
              const jsonResponse = await fetchedJson.json();
              window.open(jsonResponse.pdf, '_blank');
              this.$bvToast.toast(
                'Archivo generado',
                {
                  title: 'Listo!',
                  variant: 'primary',
                  pauseOnHover: true,
                  solid: true,
                  autoHideDelay: 2000
                }
              );
              this.back();
              this.saving = false;
            }
            break;
          case 4:
            await this.setApiError({
              codigo: 10,
              duracion: response.data.duracion,
              fecha: response.data.fecha,
              mensaje: 'Ha ocurrido un error en la generación del Pdf, por favor intenta con imágenes o elementos no tan grandes',
              seguimientoId: response.data.seguimientoId
            });
            this.saving = false;
            if (response.data.avance > 100) {
              await this.setApiError({
                codigo: 10,
                duracion: response.data.duracion,
                fecha: response.data.fecha,
                mensaje: 'Ha ocurrido un error en la generación del Pdf, por favor intenta con imágenes o elementos no tan grandes',
                seguimientoId: response.data.seguimientoId
              });
              this.saving = false;
            }
            break;
          default:
            console.log('default');
            break;
        }
      } catch (error) {
        console.log('ERROR', error);
      }
    },
    async save() {
      const isValid = await this.validateForm('custom-document');
      if (!isValid) return;

      this.error.message = '';
      this.saving = true;

      try {
        this.$bvToast.toast(
          'Guardando documento',
          {
            title: 'En camino...',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 2000
          }
        );
        const payload = {
          type: this.$route.params.type,
          query: this.$route.query,
          formData: this.formData,
        };
        const response = await ioCreateCustomDocument(payload);

        const task = await queueTask({
          proceso: 'py_febos_core_procesos',
          ejecutarDeInmediato: 'si'
        }, btoa(unescape(encodeURIComponent(JSON.stringify({
          handler: 'funcion_lambda.febos.funciones.documents.type._id.get.handler',
          type: 'IDPC',
          id: response.data.document.id,
          aplicacion: 'ED',
          dominioPortal: 'portal.escritoriodigital.cl',
          pdf: 'si',
          empresa: this.company.iut,
          token: this.userToken,
          body: {},
          stage: `${process.env.VUE_APP_AMBIENTE}`,
          pais: 'cl'
        })))));
        setTimeout(() => {
          this.verifyTask(task.data.tareaId);
        }, 1000);
      } finally {
        console.log('fin');
      }
    },
    async loadReportTypes() {
      try {
        this.loadingReportTypes = true;
        const response = await ioListOptions({
          grupoOpcion: 'io.tipos.idpc.gore',
          filtros: 'deshabilitado:0'
        });
        const { opciones } = response.data;
        this.reportTypeOptions = opciones.map((option) => ({
          value: {
            valor: option.valor,
            extra: JSON.parse(option.extra)
          },
          text: `${option.descripcion} Informe`,
          orden: option.orden
        })).sort(({ orden: x }, { orden: y }) => x - y);
      } finally {
        this.loadingReportTypes = false;
      }
    },
  },
  created() {
    this.loadReportTypes();
  },
  mounted() {},
};
</script>
<style>
.custom-control.custom-control-inline.custom-switch {
  width: 48%;
  margin-bottom: 0.5rem;
}
</style>
